import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vModelText as _vModelText, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "tw-p-4 sm:tw-p-6" }
const _hoisted_2 = { class: "tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-shadow-sm tw-shadow-slate-200/50 tw-p-3 sm:tw-p-4" }
const _hoisted_3 = { class: "tw-mb-3" }
const _hoisted_4 = { class: "tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700" }
const _hoisted_5 = { class: "tw-overflow-x-auto" }
const _hoisted_6 = { class: "tw-min-w-full tw-border-separate tw-border-spacing-0 tw-text-left" }
const _hoisted_7 = { class: "tw-divide-y tw-divide-slate-200/70" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "tw-px-3 tw-py-3 tw-text-sm tw-font-semibold tw-text-slate-900" }
const _hoisted_10 = { class: "tw-px-3 tw-py-3 tw-text-sm tw-text-slate-700" }
const _hoisted_11 = { class: "tw-px-3 tw-py-3 tw-text-sm tw-text-slate-700" }
const _hoisted_12 = { class: "tw-px-3 tw-py-3 tw-text-sm" }
const _hoisted_13 = { class: "tw-px-3 tw-py-3 tw-text-right" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4" }
const _hoisted_16 = { class: "md:tw-col-span-2" }
const _hoisted_17 = { class: "md:tw-col-span-2" }
const _hoisted_18 = { class: "tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700" }
const _hoisted_19 = { class: "md:tw-col-span-2" }
const _hoisted_20 = { class: "tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700" }
const _hoisted_21 = {
  key: 0,
  class: "tw-mt-4 tw-text-sm tw-text-rose-600"
}
const _hoisted_22 = { class: "tw-mt-6 tw-flex tw-justify-end tw-gap-2" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["disabled"]

import { computed, reactive, ref } from 'vue';
import { useApolloClient, useQuery } from '@vue/apollo-composable';
import { useAuthStore } from '@/stores/auth';
import Modal from '@/components/core/Modal/Modal.vue';
import TrucksQuery from '../../gql/drivers/Trucks.gql';
import CreateTruckMutation from '../../gql/drivers/CreateTruck.gql';
import UpdateTruckMutation from '../../gql/drivers/UpdateTruck.gql';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileTrucksTab',
  setup(__props) {

const apollo = useApolloClient();

const { result, refetch } = useQuery(TrucksQuery);

const trucks = computed(() => result.value?.trucks || []);

const showActiveOnly = ref(true);
const filteredTrucks = computed(() => {
  const list = trucks.value || [];
  return showActiveOnly.value ? list.filter((t: any) => t.isActive) : list;
});

const isModalOpen = ref(false);
const modalMode = ref<'create' | 'edit'>('create');
const editingTruckId = ref<number | null>(null);
const isSaving = ref(false);
const formError = ref<string | null>(null);

const form = reactive({
  truckNumber: '',
  licensePlate: '',
  vinNumber: '',
  isOwnerOperator: false,
  isActive: true,
});

function resetForm() {
  form.truckNumber = '';
  form.licensePlate = '';
  form.vinNumber = '';
  form.isOwnerOperator = false;
  form.isActive = true;
  formError.value = null;
}

function openCreate() {
  modalMode.value = 'create';
  editingTruckId.value = null;
  resetForm();
  isModalOpen.value = true;
}

function openEdit(truck: any) {
  modalMode.value = 'edit';
  editingTruckId.value = parseInt(String(truck.id), 10);
  form.truckNumber = truck.truckNumber || '';
  form.licensePlate = truck.licensePlate || '';
  form.vinNumber = truck.vinNumber || '';
  form.isOwnerOperator = !!truck.isOwnerOperator;
  form.isActive = truck.isActive !== false;
  formError.value = null;
  isModalOpen.value = true;
}

function closeModal() {
  isModalOpen.value = false;
}

function createdTruck() {
  refetch();
}

async function submit() {
  if (isSaving.value) return;
  formError.value = null;

  if (!form.truckNumber || !form.vinNumber) {
    formError.value = 'Truck Number and VIN are required.';
    return;
  }

  isSaving.value = true;
  try {
    if (modalMode.value === 'create') {
      await apollo.client.mutate({
        mutation: CreateTruckMutation,
        variables: {
          truckNumber: form.truckNumber,
          vin: form.vinNumber,
          licensePlate: form.licensePlate,
        },
      });
    } else {
      await apollo.client.mutate({
        mutation: UpdateTruckMutation,
        variables: {
          id: editingTruckId.value,
          truckNumber: form.truckNumber,
          vinNumber: form.vinNumber,
          licensePlate: form.licensePlate,
          isOwnerOperator: form.isOwnerOperator,
          isActive: form.isActive,
        },
      });
    }

    await refetch();
    closeModal();
  } catch (e: any) {
    formError.value = e?.message || String(e);
  } finally {
    isSaving.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "tw-mb-4 tw-flex tw-flex-col tw-gap-3 sm:tw-flex-row sm:tw-items-center sm:tw-justify-between" }, [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "tw-text-left" }, [
        _createElementVNode("h3", { class: "tw-text-lg tw-font-semibold tw-text-slate-900" }, "Trucks"),
        _createElementVNode("div", { class: "tw-mt-1 tw-text-sm tw-text-slate-600" }, "Manage your fleet.")
      ], -1)),
      _createElementVNode("button", {
        type: "button",
        class: "tw-inline-flex tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-transparent tw-bg-slate-900 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-shadow-sm tw-shadow-slate-900/10 hover:tw-bg-slate-800",
        onClick: openCreate
      }, " Add truck ")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "tw-h-4 tw-w-4",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showActiveOnly).value = $event))
          }, null, 512), [
            [_vModelCheckbox, showActiveOnly.value]
          ]),
          _cache[8] || (_cache[8] = _createTextVNode(" Show active trucks only ", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _cache[9] || (_cache[9] = _createElementVNode("thead", null, [
            _createElementVNode("tr", { class: "tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-500" }, [
              _createElementVNode("th", { class: "tw-sticky tw-top-0 tw-bg-white/80 tw-backdrop-blur tw-px-3 tw-py-3" }, "Truck #"),
              _createElementVNode("th", { class: "tw-sticky tw-top-0 tw-bg-white/80 tw-backdrop-blur tw-px-3 tw-py-3" }, "VIN"),
              _createElementVNode("th", { class: "tw-sticky tw-top-0 tw-bg-white/80 tw-backdrop-blur tw-px-3 tw-py-3" }, "License"),
              _createElementVNode("th", { class: "tw-sticky tw-top-0 tw-bg-white/80 tw-backdrop-blur tw-px-3 tw-py-3" }, "Status"),
              _createElementVNode("th", { class: "tw-sticky tw-top-0 tw-bg-white/80 tw-backdrop-blur tw-px-3 tw-py-3" })
            ])
          ], -1)),
          _createElementVNode("tbody", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredTrucks.value, (truck) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: truck.id,
                class: "tw-cursor-pointer hover:tw-bg-slate-50/70",
                onClick: ($event: any) => (openEdit(truck))
              }, [
                _createElementVNode("td", _hoisted_9, _toDisplayString(truck.truckNumber), 1),
                _createElementVNode("td", _hoisted_10, _toDisplayString(truck.vinNumber), 1),
                _createElementVNode("td", _hoisted_11, _toDisplayString(truck.licensePlate || '—'), 1),
                _createElementVNode("td", _hoisted_12, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-full tw-px-2.5 tw-py-0.5 tw-text-xs tw-font-semibold", truck.isActive ? 'tw-bg-emerald-100 tw-text-emerald-900' : 'tw-bg-slate-200 tw-text-slate-800'])
                  }, _toDisplayString(truck.isActive ? 'Active' : 'Inactive'), 3)
                ]),
                _createElementVNode("td", _hoisted_13, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "tw-inline-flex tw-items-center tw-gap-2 tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/70 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-slate-800 hover:tw-bg-white",
                    onClick: _withModifiers(($event: any) => (openEdit(truck)), ["stop"])
                  }, " Edit ", 8, _hoisted_14)
                ])
              ], 8, _hoisted_8))
            }), 128))
          ])
        ])
      ])
    ]),
    _createVNode(Modal, {
      isOpen: isModalOpen.value,
      "onUpdate:isOpen": _cache[6] || (_cache[6] = ($event: any) => ((isModalOpen).value = $event)),
      modalId: "truck-modal",
      title: modalMode.value === 'create' ? 'Add Truck' : 'Edit Truck',
      maxWidth: "2xl"
    }, {
      content: _withCtx(({ close }) => [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", null, [
            _cache[10] || (_cache[10] = _createElementVNode("label", { class: "tw-block tw-text-sm tw-font-medium tw-text-slate-700" }, "Truck Number", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.truckNumber) = $event)),
              type: "text",
              class: "tw-mt-1 tw-w-full tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40"
            }, null, 512), [
              [_vModelText, form.truckNumber]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[11] || (_cache[11] = _createElementVNode("label", { class: "tw-block tw-text-sm tw-font-medium tw-text-slate-700" }, "License Plate", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.licensePlate) = $event)),
              type: "text",
              class: "tw-mt-1 tw-w-full tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40"
            }, null, 512), [
              [_vModelText, form.licensePlate]
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _cache[12] || (_cache[12] = _createElementVNode("label", { class: "tw-block tw-text-sm tw-font-medium tw-text-slate-700" }, "VIN", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.vinNumber) = $event)),
              type: "text",
              class: "tw-mt-1 tw-w-full tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/40"
            }, null, 512), [
              [_vModelText, form.vinNumber]
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("label", _hoisted_18, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "tw-h-4 tw-w-4",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.isOwnerOperator) = $event))
              }, null, 512), [
                [_vModelCheckbox, form.isOwnerOperator]
              ]),
              _cache[13] || (_cache[13] = _createTextVNode(" Is Owner Operator? ", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("label", _hoisted_20, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "tw-h-4 tw-w-4",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.isActive) = $event))
              }, null, 512), [
                [_vModelCheckbox, form.isActive]
              ]),
              _cache[14] || (_cache[14] = _createTextVNode(" Is Active? ", -1))
            ])
          ])
        ]),
        (formError.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(formError.value), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("button", {
            type: "button",
            class: "tw-inline-flex tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-800 hover:tw-bg-slate-50",
            onClick: close
          }, " Cancel ", 8, _hoisted_23),
          _createElementVNode("button", {
            type: "button",
            class: "tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-rounded-xl tw-border tw-border-transparent tw-bg-slate-900 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white hover:tw-bg-slate-800 disabled:tw-opacity-60",
            disabled: isSaving.value,
            onClick: submit
          }, [
            (isSaving.value)
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 0,
                  icon: "circle-notch",
                  spin: "",
                  class: "tw-h-4 tw-w-4"
                }))
              : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 1,
                  icon: "check",
                  class: "tw-h-4 tw-w-4"
                })),
            _cache[15] || (_cache[15] = _createTextVNode(" Save ", -1))
          ], 8, _hoisted_24)
        ])
      ]),
      _: 1
    }, 8, ["isOpen", "title"])
  ]))
}
}

})